import { render, staticRenderFns } from "./client-template-item.vue?vue&type=template&id=b9cd55e6&scoped=true"
import script from "./client-template-item.vue?vue&type=script&lang=js"
export * from "./client-template-item.vue?vue&type=script&lang=js"
import style0 from "./client-template-item.vue?vue&type=style&index=0&id=b9cd55e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cd55e6",
  null
  
)

export default component.exports